var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470 470",
    style: {
      enableBackground: "new 0 0 470 470"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC75"
    },
    d: "M191.25,50.9v25H442.5c6.893,0,12.5-5.607,12.5-12.5s-5.607-12.5-12.5-12.5H191.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.25,
    y: 50.9,
    style: {
      fill: "#98D9D5"
    },
    width: 75,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#274B6D"
    },
    d: "M37.5,85.9c7.218,0,26.876-3.103,48.75-8.372V49.272C64.376,44.003,44.718,40.9,37.5,40.9 C25.094,40.9,15,50.994,15,63.4S25.094,85.9,37.5,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M37.5,100.9c10.188,0,34.121-4.191,57.184-10H442.5c15.163,0,27.5-12.337,27.5-27.5 s-12.337-27.5-27.5-27.5H94.684c-23.063-5.809-46.995-10-57.184-10C16.822,25.9,0,42.723,0,63.4S16.822,100.9,37.5,100.9z  M37.5,40.9c7.218,0,26.876,3.103,48.75,8.372v28.256C64.376,82.797,44.718,85.9,37.5,85.9C25.094,85.9,15,75.807,15,63.4 S25.094,40.9,37.5,40.9z M455,63.4c0,6.893-5.607,12.5-12.5,12.5H191.25v-25H442.5C449.393,50.9,455,56.508,455,63.4z M176.25,50.9 v25h-75v-25H176.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2EBD9"
    },
    d: "M432.5,130.9h-395c-12.406,0-22.5,10.094-22.5,22.5V406.6c0,12.406,10.094,22.5,22.5,22.5h395 c12.406,0,22.5-10.094,22.5-22.5V153.4C455,140.994,444.906,130.9,432.5,130.9z M93.35,414.1c-34.903,0-63.3-28.396-63.3-63.3 s28.396-63.3,63.3-63.3c10.881,0,21.629,2.822,31.083,8.162c3.606,2.037,4.879,6.612,2.842,10.219 c-0.082,0.146-0.175,0.28-0.265,0.418c4.092,3.1,7.741,6.75,10.841,10.841c0.138-0.09,0.273-0.183,0.418-0.265 c3.607-2.036,8.183-0.765,10.219,2.842c5.341,9.454,8.163,20.203,8.163,31.083C156.65,385.703,128.254,414.1,93.35,414.1z  M93.35,272.5c-34.903,0-63.3-28.396-63.3-63.3s28.396-63.3,63.3-63.3c34.904,0,63.301,28.396,63.301,63.3 S128.254,272.5,93.35,272.5z M235,414.1c-34.903,0-63.3-28.396-63.3-63.3s28.396-63.3,63.3-63.3s63.3,28.396,63.3,63.3 S269.903,414.1,235,414.1z M235,272.5c-34.903,0-63.3-28.396-63.3-63.3s28.396-63.3,63.3-63.3s63.3,28.396,63.3,63.3 S269.903,272.5,235,272.5z M376.65,414.1c-34.904,0-63.301-28.396-63.301-63.3s28.396-63.3,63.301-63.3 c34.903,0,63.3,28.396,63.3,63.3S411.554,414.1,376.65,414.1z M376.65,272.5c-34.904,0-63.301-28.396-63.301-63.3 s28.396-63.3,63.301-63.3c34.903,0,63.3,28.396,63.3,63.3S411.554,272.5,376.65,272.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2484B"
    },
    d: "M93.35,160.9c-26.633,0-48.3,21.667-48.3,48.3s21.667,48.3,48.3,48.3s48.301-21.667,48.301-48.3 S119.982,160.9,93.35,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6E1D"
    },
    d: "M235,160.9c-26.633,0-48.3,21.667-48.3,48.3s21.667,48.3,48.3,48.3s48.3-21.667,48.3-48.3 S261.633,160.9,235,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC75"
    },
    d: "M376.65,160.9c-26.633,0-48.301,21.667-48.301,48.3s21.668,48.3,48.301,48.3s48.3-21.667,48.3-48.3 S403.283,160.9,376.65,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#185F8D"
    },
    d: "M127.009,306.3c-2.146,3.279-6.491,4.378-9.953,2.423c-7.208-4.071-15.405-6.223-23.706-6.223 c-26.633,0-48.3,21.667-48.3,48.3s21.667,48.3,48.3,48.3s48.301-21.667,48.301-48.3c0-8.301-2.152-16.498-6.224-23.706 c-1.955-3.461-0.856-7.807,2.423-9.953C134.75,313.049,131.1,309.399,127.009,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M235,302.5c-26.633,0-48.3,21.667-48.3,48.3s21.667,48.3,48.3,48.3s48.3-21.667,48.3-48.3 S261.633,302.5,235,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98D9D5"
    },
    d: "M376.65,302.5c-26.633,0-48.301,21.667-48.301,48.3s21.668,48.3,48.301,48.3s48.3-21.667,48.3-48.3 S403.283,302.5,376.65,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M432.5,115.9h-395C16.822,115.9,0,132.723,0,153.4V406.6c0,20.678,16.822,37.5,37.5,37.5h395 c20.678,0,37.5-16.822,37.5-37.5V153.4C470,132.723,453.178,115.9,432.5,115.9z M455,406.6c0,12.406-10.094,22.5-22.5,22.5h-395 c-12.406,0-22.5-10.094-22.5-22.5V153.4c0-12.406,10.094-22.5,22.5-22.5h395c12.406,0,22.5,10.094,22.5,22.5V406.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M93.35,145.9c-34.903,0-63.3,28.396-63.3,63.3s28.396,63.3,63.3,63.3 c34.904,0,63.301-28.396,63.301-63.3S128.254,145.9,93.35,145.9z M93.35,257.5c-26.633,0-48.3-21.667-48.3-48.3 s21.667-48.3,48.3-48.3s48.301,21.667,48.301,48.3S119.982,257.5,93.35,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M235,145.9c-34.903,0-63.3,28.396-63.3,63.3s28.396,63.3,63.3,63.3s63.3-28.396,63.3-63.3 S269.903,145.9,235,145.9z M235,257.5c-26.633,0-48.3-21.667-48.3-48.3s21.667-48.3,48.3-48.3s48.3,21.667,48.3,48.3 S261.633,257.5,235,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M376.65,145.9c-34.904,0-63.301,28.396-63.301,63.3s28.396,63.3,63.301,63.3 c34.903,0,63.3-28.396,63.3-63.3S411.554,145.9,376.65,145.9z M376.65,257.5c-26.633,0-48.301-21.667-48.301-48.3 s21.668-48.3,48.301-48.3s48.3,21.667,48.3,48.3S403.283,257.5,376.65,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M235,287.5c-34.903,0-63.3,28.396-63.3,63.3s28.396,63.3,63.3,63.3s63.3-28.396,63.3-63.3 S269.903,287.5,235,287.5z M235,399.1c-26.633,0-48.3-21.667-48.3-48.3s21.667-48.3,48.3-48.3s48.3,21.667,48.3,48.3 S261.633,399.1,235,399.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M376.65,287.5c-34.904,0-63.301,28.396-63.301,63.3s28.396,63.3,63.301,63.3 c34.903,0,63.3-28.396,63.3-63.3S411.554,287.5,376.65,287.5z M376.65,399.1c-26.633,0-48.301-21.667-48.301-48.3 s21.668-48.3,48.301-48.3s48.3,21.667,48.3,48.3S403.283,399.1,376.65,399.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#082947"
    },
    d: "M138.269,316.875c-0.145,0.082-0.28,0.175-0.418,0.265c-3.28,2.147-4.379,6.493-2.424,9.954 c4.071,7.208,6.224,15.405,6.224,23.706c0,26.633-21.668,48.3-48.301,48.3s-48.3-21.667-48.3-48.3s21.667-48.3,48.3-48.3 c8.301,0,16.498,2.151,23.706,6.223c3.463,1.956,7.807,0.856,9.953-2.423c0.091-0.139,0.183-0.273,0.265-0.419 c2.037-3.606,0.765-8.182-2.842-10.219c-9.454-5.34-20.202-8.162-31.083-8.162c-34.903,0-63.3,28.396-63.3,63.3 s28.396,63.3,63.3,63.3c34.904,0,63.301-28.396,63.301-63.3c0-10.88-2.822-21.629-8.163-31.083 C146.451,316.11,141.876,314.839,138.269,316.875z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b5dddbecf0d2ae5a969e019f5b098cf.svg";
export { ForwardRef as ReactComponent };